module.exports = __webpack_public_path__ + "static/media/exit.19f206ee.svg";